<template>
  <div class="social-links-container">
    <a
      v-for="(item, index) in type.social_links"
      :key="index"
      :href="item.url"
      target="_blank"
      :aria-label="`${item.social_type} icon`"
      :name="`${item.social_type} icon`"
    >
      <FontAwesomeIcon
        v-if="useLowerCase(item.social_type) == 'facebook'"
        class="fa-social"
        icon="fa-brands fa-facebook-f"
      />
      <FontAwesomeIcon
        v-if="useLowerCase(item.social_type) == 'instagram'"
        class="fa-socials"
        icon="fa-brands fa-instagram"
      />
      <FontAwesomeIcon
        v-if="useLowerCase(item.social_type) == 'twitter'"
        class="fa-socials"
        icon="fa-brands fa-x-twitter"
      />
      <FontAwesomeIcon
        v-if="useLowerCase(item.social_type) == 'tiktok'"
        class="fa-socials"
        icon="fa-brands fa-tiktok"
      />
      <FontAwesomeIcon
        v-if="useLowerCase(item.social_type) == 'youtube'"
        class="fa-socials"
        icon="fa-brands fa-youtube"
      />
      <FontAwesomeIcon
        v-if="useLowerCase(item.social_type) == 'pinterest'"
        class="fa-socials"
        icon="fa-brands fa-pinterest-p"
      />
      <FontAwesomeIcon
        v-if="useLowerCase(item.social_type) == 'Yelp'"
        class="fa-socials"
        icon="fa-brands fa-yelp"
      />
      <FontAwesomeIcon
        v-if="useLowerCase(item.social_type) == 'Weibo'"
        class="fa-socials"
        icon="fa-brands fa-weibo"
      />
    </a>
    <nuxt-link
      v-if="has_comment"
      to="/"
      aria-label="comment icon"
      name="comment icon"
    >
      <FontAwesomeIcon
        class="fa-socials"
        icon="fas fa-comments"
      />
    </nuxt-link>
  </div>
</template>

<script setup>
// PROPS
const props = defineProps(["type", "property", "has_comment"]);
</script>

<style lang="scss" scoped>
.social-links-container {
  color: $black;
  margin: 10px 0;

  a {
    padding-right: 1.5em !important;
    .svg-inline--fa {
      height: 1.25em;
    }
  }
}
</style>
